import { render } from "./AsideLine.vue?vue&type=template&id=b5bbc0ac&scoped=true&ts=true"
import script from "./AsideLine.vue?vue&type=script&lang=ts"
export * from "./AsideLine.vue?vue&type=script&lang=ts"

import "./AsideLine.vue?vue&type=style&index=0&id=b5bbc0ac&lang=scss&scoped=true"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bbc0ac"]])

export default __exports__